export enum EPaths {
    AUTH = 'auth',
    CALL = 'conference/:conferenceId',
    DEVICE_PERMISSION_DENIED = 'device-permission-denied',
    EXIT = 'exit',
    PREPARATION = 'preparation',
    RECORD = 'record/:recordId',
    ROOT = '/',
    UNAVAILABLE_CONTENT = 'unavailable-content',
}
